<adapt-collapsible-dashboard-element [name]="section.title"
                                     [url]="linkObject"
                                     [collapsed]="count === 0 && !isLoading && !error"
                                     [useScrollView]="false">
    @if (count !== 0 || totalCount !== count) {
        <span adapt-collapsible-header-action
              [adaptTooltip]="countTooltip"
              [adaptTooltipIsHtml]="true"
              class="badge activity-badge"
              data-test="activity-section-count">{{ countText }}</span>
    }

    <ng-container adapt-collapsible-header-action-right>
        <ng-content select="[adapt-collapsible-header-action-right]"></ng-content>
    </ng-container>

    <div *adaptLoading="isLoading"
         class="d-flex flex-row flex-wrap gap-4">
        <ng-content></ng-content>

        @if (count === 0 && fallbackText && !error) {
            <div class="pt-3">
                @if (count === totalCount) {
                    {{ fallbackText }}
                } @else {
                    There are {{ section.title.toLocaleLowerCase() }} that are hidden by your selected filter options.
                }
            </div>
        }

        @if (error) {
            <div class="alert alert-danger flex-grow-1 mt-3 mb-0"
                 role="alert">
                There was a problem loading your
                {{ section.title.toLowerCase() }}: {{ error }}
            </div>
        }
    </div>
</adapt-collapsible-dashboard-element>
